export { default } from './IconPicker';
